/** FlowGen BPMN xml ids are `{elementType}_{summaryId}` (e.g. task_act-review). */
export function summaryIdFromBpmnXmlId(bpmnId: string): string | null {
	const idx = bpmnId.indexOf('_')
	if (idx <= 0 || idx >= bpmnId.length - 1) {
		return null
	}
	return bpmnId.slice(idx + 1)
}
